const prefix = 'insurance';

export const CREATE_SPRINT_PURCHASE = `${prefix}/CREATE_SPRINT_PURCHASE`;
export const CREATE_ATT_PURCHASE = `${prefix}/CREATE_ATT_PURCHASE`;
export const CREATE_QUICK_PURCHASE = `${prefix}/CREATE_QUICK_PURCHASE`;
